import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaClock,
  FaSearch,
  FaArrowRight,
  FaUsers,
  FaBuilding,
  FaChartLine,
  FaHandshake,
  FaTrophy,
} from "react-icons/fa";
import PublicNavbar from "../../components/public/Navbar";
import Footer from "../../components/public/Footer";
import "../../styles/jobs.css";

const Jobs = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stats = [
    {
      icon: <FaBuilding />,
      number: "500+",
      label: "Partner Companies",
      color: "#3498DB",
    },
    {
      icon: <FaUsers />,
      number: "2000+",
      label: "Successfully Placed",
      color: "#2ECC71",
    },
    {
      icon: <FaChartLine />,
      number: "95%",
      label: "Placement Rate",
      color: "#FF8C00",
    },
    {
      icon: <FaTrophy />,
      number: "₹5.2L",
      label: "Average Package",
      color: "#9B59B6",
    },
  ];

  const features = [
    {
      icon: <FaSearch />,
      title: "Smart Job Search",
      description: "Find jobs matching your skills with advanced filters",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Pan India Opportunities",
      description: "Jobs available across all major cities in India",
    },
    {
      icon: <FaClock />,
      title: "Real-time Updates",
      description: "Get instant notifications for new job postings",
    },
    {
      icon: <FaHandshake />,
      title: "Placement Support",
      description: "Dedicated placement assistance and career guidance",
    },
  ];

  return (
    <div className="jobs-page-wrapper">
      <PublicNavbar />

      {/* Navbar Spacer */}
      <div className="jobs-page-nav-spacer"></div>

      {/* Hero Section */}
      <div className="jobs-page-hero">
        <div className="jobs-page-hero-bubbles">
          <div className="jobs-page-bubble"></div>
          <div className="jobs-page-bubble"></div>
          <div className="jobs-page-bubble"></div>
          <div className="jobs-page-bubble"></div>
          <div className="jobs-page-bubble"></div>
        </div>
        <Container>
          <Row className="align-items-center">
            <Col lg={7}>
              <div className="jobs-page-hero-content">
                <div className="jobs-page-hero-badge">
                  <span>🚀</span>
                  <span>10,000+ Live Jobs</span>
                  <span>✨</span>
                </div>
                <h1 className="jobs-page-hero-title">
                  Find Your{" "}
                  <span className="jobs-page-highlight">Dream Job</span>
                </h1>
                <p className="jobs-page-hero-description">
                  Explore thousands of job opportunities from top companies
                  across India. Your next career move starts here with Sensible
                  Academy's exclusive job portal.
                </p>
                <div className="jobs-page-hero-features">
                  <div className="jobs-page-feature-tag">
                    <FaSearch /> Easy Search
                  </div>
                  <div className="jobs-page-feature-tag">
                    <FaMapMarkerAlt /> Pan India Jobs
                  </div>
                  <div className="jobs-page-feature-tag">
                    <FaClock /> Real-time Updates
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <div className="jobs-page-hero-illustration">
                <div className="jobs-page-floating-icon jobs-page-icon-1">
                  🎯
                </div>
                <div className="jobs-page-floating-icon jobs-page-icon-2">
                  💼
                </div>
                <div className="jobs-page-floating-icon jobs-page-icon-3">
                  🏆
                </div>
                <div className="jobs-page-floating-icon jobs-page-icon-4">
                  📈
                </div>
                <div className="jobs-page-floating-icon jobs-page-icon-5">
                  🚀
                </div>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                  alt="Job Search"
                  className="jobs-page-main-illustration"
                />
              </div>
            </Col>
          </Row>
        </Container>
        <div className="jobs-page-hero-wave">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
            ></path>
          </svg>
        </div>
      </div>

      {/* Stats Section */}
      <Container className="jobs-page-container py-5">
        <Row className="g-4">
          {stats.map((stat, index) => (
            <Col md={3} sm={6} key={index}>
              <div className="jobs-page-stat-card">
                <div
                  className="jobs-page-stat-icon"
                  style={{ background: stat.color }}
                >
                  {stat.icon}
                </div>
                <h3 className="jobs-page-stat-number">{stat.number}</h3>
                <p className="jobs-page-stat-label">{stat.label}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Features Section */}
      {/* <div className="jobs-page-features-section">
        <Container>
          <div className="jobs-page-section-header text-center">
            <h2>Why Choose Our <span className="jobs-page-highlight">Job Portal</span> ✨</h2>
            <p>We provide everything you need to land your dream job</p>
          </div>
          <Row className="g-4">
            {features.map((feature, index) => (
              <Col md={3} sm={6} key={index}>
                <div className="jobs-page-feature-card">
                  <div className="jobs-page-feature-icon-wrapper">
                    {feature.icon}
                  </div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div> */}

      {/* Iframe Section */}
      <section className="jobs-page-iframe-section">
        <Container fluid className="px-0">
          <div className="jobs-page-iframe-container">
            {!iframeLoaded && (
              <div className="jobs-page-iframe-loader">
                <Spinner animation="border" variant="primary" />
                <p>Loading job portal...</p>
              </div>
            )}
            <iframe
              src="https://optimhire.com/d/Search-job-iframe?ref_code=piyush-jain&skill=&positions=&dark_color=3f73ee&light_color=3b74e8"
              title="Job Search Portal"
              className="jobs-page-iframe"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              onLoad={() => setIframeLoaded(true)}
              style={{ display: iframeLoaded ? "block" : "none" }}
            ></iframe>
          </div>
        </Container>
      </section>

      {/* Bottom CTA Section */}
      <div className="jobs-page-cta-section">
        <Container>
          <Row className="align-items-center justify-content-center text-center">
            <Col lg={8}>
              <div className="jobs-page-cta-content">
                <div className="jobs-page-cta-icon">🎯</div>
                <h2>Need Career Guidance?</h2>
                <p>
                  Our expert career counselors are here to help you find the
                  right job that matches your skills and aspirations. Get
                  personalized guidance today!
                </p>
                <div className="jobs-page-cta-buttons">
                  <Button
                    className="jobs-page-cta-primary"
                    onClick={() => (window.location.href = "/contact")}
                  >
                    Talk to Counselor <FaArrowRight className="ms-2" />
                  </Button>
                  <Button
                    className="jobs-page-cta-secondary"
                    onClick={() => (window.location.href = "/courses")}
                  >
                    Explore Courses
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </div>
  );
};

export default Jobs;
